import styled from 'styled-components'
import { IconCross } from '../../iconography/Icons/Icons'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 200px;
`

export const List = styled.div`
  background: ${props => props.theme.color.onPrimaryLight};
  max-height: 60vh;
  overflow-y: auto;
  position: absolute;
  z-index: 10;
  width: calc(100% + 50px);
  padding: 4px;
  top: 100%;
  border-radius: 4px;
  box-shadow: 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%);
  margin-top: 8px;
  box-sizing: border-box;
`

type OptionProps = {
  isChild?: boolean
  isParent?: boolean
}
export const Option = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  min-height: 40px;
  font-size: 14px;
  line-height: 16px;
  color: ${props => props.theme.color.onPrimaryDark};
  font-weight: ${(props: OptionProps) => (props.isParent ? 700 : 500)};
  border-radius: 4px;

  button {
    cursor: pointer;
  }

  &:hover {
    background: #deebff;
  }

  &[data-children-filtered='true'] {
    cursor: not-allowed;
  }

  &[data-children-filtered='true'] button {
    pointer-events: none;
  }

  padding: 8px 12px 8px
    ${(props: OptionProps) => {
      if (props.isChild) return '38px'
      if (props.isParent) return '0'
      return '20px'
    }};
`

export const OptionInner = styled.div`
  display: inline-flex;
  align-items: center;
  flex-grow: 1;

  [data-children-filtered='true'] & {
    cursor: not-allowed;

    > * {
      pointer-events: none;
    }
  }
`

export const Only = styled.button`
  margin-left: auto;
  opacity: 0;
  padding: 2px 6px;
  font-size: 12px;
  transition: 0.3s all;
  height: 20px;
  line-height: 12px;
  position: absolute;
  top: 50%;
  right: 8px;
  background: ${props => props.theme.color.onPrimaryLight};
  color: ${props => props.theme.color.primary600};
  border: 1px solid ${props => props.theme.color.primary600};
  border-radius: 4px;
  transform: translateY(-150%);
  min-width: 95px;

  ${Option}:hover & {
    opacity: 1;
    transform: translateY(-50%);
    box-shadow: 0 0 0 5px #deebff, 0 0 12px 5px #deebff;
  }

  [data-children-filtered='true']:hover .only {
    opacity: 0;
  }

  &:hover {
    background: ${props => props.theme.color.primary50};
  }
`

type NestedListProps = {
  isOpen: boolean
}

export const NestedList = styled.div`
  grid-template-columns: 1fr;
  display: ${(props: NestedListProps) => (props.isOpen ? 'grid' : 'none')};
  border-left: none;
  border-right: none;
  background: ${props => props.theme.color.primary25};
  border-radius: 4px;
`

export const Control = styled.div`
  min-height: 32px;
  font-size: 14px;
  line-height: 20px;
  border: 1px solid ${props => props.theme.color.onSurfaceLowEmphasys};
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: 0.3s box-shadow, 0.3s border-color;
  cursor: pointer;

  &:hover {
    border-color: ${props => props.theme.color.onPrimaryMid};
  }

  &[data-is-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.7;
  }

  &[data-is-open='true'] {
    border-color: ${props => props.theme.color.primary600};
  }
`

export const Value = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  padding: 2px;

  [data-is-typing='true'] & {
    width: 0;
    opacity: 0;
    overflow: hidden;
    padding: 0;
  }

  [data-is-empty='true'] & {
    color: #808080;
  }
`
export const SearchField = styled.input`
  background: no-repeat;
  border: none;
  font-size: 14px;
  line-height: 20px;
  width: 20px;
  cursor: text;

  &:focus {
    outline: none;
  }

  [data-is-typing='true'] & {
    width: 100%;
  }

  ${props => props.theme.media.mobile`
    font-size: 16px;
  `}
`

export const ValueContainer = styled.div`
  padding: 2px 0 2px 8px;
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  cursor: default;
`

export const ClearButton = styled(IconCross)`
  flex-shrink: 0;
  margin: 0 12px 0 8px;
  cursor: pointer;
  fill: ${props => props.theme.color.onPrimaryDark};
  width: 10px;
  height: 10px;

  [data-is-empty='true'] & {
    opacity: 0;
  }
`

export const DropdownIndicator = styled.span`
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  margin-right: 15px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${props => props.theme.color.onPrimaryDark};
  }

  &[data-is-open='true']::before {
    border-bottom: 5px solid ${props => props.theme.color.onPrimaryDark};
    border-top: none;
  }
`

export const NestedIndicator = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 7px solid ${props => props.theme.color.onPrimaryDark};
  }

  &[data-is-open='true']::before {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 7px solid ${props => props.theme.color.onPrimaryDark};
    margin-top: 5px;
  }
`

export const EmptyMsg = styled.div`
  text-align: center;
  color: ${props => props.theme.color.onSurfaceLowEmphasys};
  padding: 12px;
`

export const Label = styled.label`
  cursor: pointer;
  flex-grow: 1;

  [data-children-filtered='true'] & {
    pointer-events: none;
  }
`

export const LabelWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
